import { render, staticRenderFns } from "./TelephoneAttentionChannel.vue?vue&type=template&id=07b5a034&"
import script from "./TelephoneAttentionChannel.vue?vue&type=script&lang=js&"
export * from "./TelephoneAttentionChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports